import { render, staticRenderFns } from "./doclist.vue?vue&type=template&id=5d4c1af4&"
import script from "./doclist.vue?vue&type=script&lang=js&"
export * from "./doclist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports